import { Pencil } from "lucide-react";
import PropTypes from "prop-types";
import StatusChip from "@components/ui-components/status-chip";
import { FREQUENCY_LABEL, PAYMENT_MODEL_LABEL, PLATFORM_LABEL,
    PAYMENT_SETUP_STATUS_LABEL, PAYMENT_SETUP_STATUS_TONE
} from "@constants/panel/common";

const ConfigRow = ({ label, value }) => (
    <div className="flex items-center justify-between gap-3 py-3 text-sm">
        <dt className="text-muted">{label}</dt>
        <dd className="text-right font-medium text-gray-900">{value}</dd>
    </div>
);

ConfigRow.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node
};

// "Frequency" is the debit-note cycle — a self-payout brand never has one raised
// against it, so the row would always read "—".
const ConfigurationCard = ({ brand, isSelfPayout, onEdit }) => (
    <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold text-gray-900">Configuration</h3>
            <button
                type="button"
                onClick={onEdit}
                className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-2.5 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50">
                <Pencil className="h-3.5 w-3.5" />
                Edit
            </button>
        </div>
        <dl className="mt-2 divide-y divide-gray-100">
            <ConfigRow label="Payment model" value={PAYMENT_MODEL_LABEL[brand.payment_model] || brand.payment_model || "—"} />
            {!isSelfPayout && <ConfigRow label="Debit note frequency" value={FREQUENCY_LABEL[brand.debit_note_frequency] || brand.debit_note_frequency || "—"} />}
            <ConfigRow label="KYC window" value={brand.kyc_window ? `${brand.kyc_window} days` : "—"} />
            <ConfigRow
                label="Setup status"
                value={brand.payment_setup_status
                    ? <StatusChip tone={PAYMENT_SETUP_STATUS_TONE[brand.payment_setup_status] || "neutral"} label={PAYMENT_SETUP_STATUS_LABEL[brand.payment_setup_status] || brand.payment_setup_status} />
                    : "—"} />
            <ConfigRow label="Platform" value={PLATFORM_LABEL[brand.platform_name] || brand.platform_name || "—"} />
            {/* <ConfigRow label="Country" value={brand.country ? (COUNTRY_LABEL[brand.country.toUpperCase()] || brand.country) : "—"} /> */}
        </dl>
    </div>
);

ConfigurationCard.propTypes = {
    brand       : PropTypes.object.isRequired,
    isSelfPayout: PropTypes.bool,
    onEdit      : PropTypes.func.isRequired
};

export default ConfigurationCard;
